import { c as _c } from "react/compiler-runtime";
import type { CSSProperties, ReactNode } from 'react';
import { cn } from '@/app/utils/cn';
const getImageSize = (width, height) => {
  const dimension = width / height;
  const isPortrait = width < height;
  return {
    minWidth: isPortrait ? '380px' : '676px',
    maxWidth: '196px',
    dimension: dimension
  };
};
interface ContentWrapperProps {
  children: ReactNode;
  imageWidth: number;
  imageHeight: number;
  className?: string;
}
export const ContentWrapper = t0 => {
  const $ = _c(14);
  const {
    children,
    imageWidth,
    imageHeight,
    className
  } = t0;
  let t1;
  if ($[0] !== imageHeight || $[1] !== imageWidth) {
    t1 = getImageSize(imageWidth, imageHeight);
    $[0] = imageHeight;
    $[1] = imageWidth;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const imageSize = t1;
  const t2 = `${imageWidth} / ${imageHeight}`;
  let t3;
  if ($[3] !== imageSize.dimension || $[4] !== imageSize.maxWidth || $[5] !== imageSize.minWidth || $[6] !== t2) {
    t3 = {
      "--min-width": imageSize.minWidth,
      "--max-width": imageSize.maxWidth,
      "--dimension": imageSize.dimension,
      "--aspect-ratio": t2
    };
    $[3] = imageSize.dimension;
    $[4] = imageSize.maxWidth;
    $[5] = imageSize.minWidth;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = t3 as CSSProperties;
  let t5;
  if ($[8] !== className) {
    t5 = cn("group relative", className);
    $[8] = className;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== children || $[11] !== t4 || $[12] !== t5) {
    t6 = <div style={t4} className={t5}>{children}</div>;
    $[10] = children;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};